import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import { z } from 'zod';

import { ButtonLink } from '@/components/router/ButtonLink';
import { useAppForm } from '@/hooks/useAppForm';
import type { InitializePasswordResetDto } from '@/modules/api/backend';

interface PasswordResetRequestFormProps {
  onSubmit: (values: InitializePasswordResetDto) => Promise<void>;
}

export function PasswordResetRequestForm({ onSubmit }: PasswordResetRequestFormProps) {
  const form = useAppForm({
    defaultValues: {
      email: '',
    },
    onSubmit: async ({ value }) => {
      await onSubmit(value);
    },
  });

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        form.handleSubmit();
      }}
    >
      <Stack spacing={2}>
        <Typography variant="body1">
          Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.
        </Typography>

        <form.AppField
          name="email"
          validators={{
            onChange: z.email(),
          }}
        >
          {(field) => <field.TextField label="E-Mail-Adresse" type="email" />}
        </form.AppField>

        <form.Subscribe selector={(formState) => [formState.canSubmit, formState.isSubmitting]}>
          {([canSubmit, isSubmitting]) => (
            <form.Subscribe selector={(formState) => formState.isSubmitting}>
              <Stack alignItems="center" direction="row" gap={3} justifyContent="flex-end">
                <ButtonLink color="primary" to="/login" variant="outlined">
                  Zurück zum Login
                </ButtonLink>
                <Button disabled={!canSubmit} type="submit" variant="contained">
                  {isSubmitting ? <CircularProgress /> : 'Zurücksetzen'}
                </Button>
              </Stack>
            </form.Subscribe>
          )}
        </form.Subscribe>
      </Stack>
    </form>
  );
}
